import { Facehash, FacehashProps } from 'facehash';

const FACEHASH_COLORS = [
  '#2A46FF',
  '#0091FF',
  '#00B8D9',
  '#00B884',
  '#3CCB7F',
  '#7BD389',
  '#F6B93B',
  '#FF8C42',
  '#FF6B6B',
  '#EE5A24',
  '#C44536',
  '#9B59B6',
  '#6C5CE7',
  '#5758BB',
];

interface IUserAvatarProps extends FacehashProps {
  name: string;
  email?: string;
  size?: 20 | 24 | 28 | 32 | 36 | 40 | 44 | 48;
  shape?: 'square' | 'squircle' | 'round';
}

const BORDER_RADIUS = {
  square: '1px',
  squircle: '30%',
  round: '100%',
} as const;

const UserAvatar = ({ name, email, size = 32, shape = 'square', ...props }: IUserAvatarProps) => {
  return (
    <Facehash
      name={name ?? email ?? ''}
      size={size}
      colors={FACEHASH_COLORS}
      variant="gradient"
      enableBlink
      showInitial
      style={{ borderRadius: BORDER_RADIUS[shape], flexShrink: 0 }}
      {...props}
    />
  );
};

export default UserAvatar;
